export namespace NCampaignTracking {
    export const CMS_CONFIG = 'campaign-tracking-config';

    export const LOCAL_STORAGE_ID = 'campaign-tracking-params';

    export interface ICmsConfigDataContent {
        expiration?: number;
    }

    export const PARAMS = [
        'gclid',
        'gaclid',
        'fbclid',
        'msclid',
        'msclkid',
        'referer',
        'utm_source',
        'utm_medium',
        'utm_term',
        'utm_content',
        'utm_campaign',
        'clid'
    ];

    export interface ILocalStorageParams {
        [key: string]: ILocalStorageParam;
    }

    export interface ILocalStorageParam {
        value: any;
        date: number;
    }
}
